namespace TabAurous.Common {
    @Serenity.Decorators.registerEditor()
    export class CustomerPrefixEditor extends Serenity.Select2Editor<any, any> {
        constructor(container: JQuery) {
            super(container, null);
            this.addOption("Mr", "Mr");
            this.addOption("Mrs", "Mrs");
            this.addOption("Ms", "Ms");
            this.addOption("Dr", "Dr");
        }
    }
}